import './index.scss'

$('footer .backtop').on('click',function(){
  $("html, body").animate({
    scrollTop: 0
  }, {duration: 500,easing: "swing"});
  return false;
})